import cx from 'classnames';
import React, { forwardRef } from 'react';
import { BaseLink } from './base-link';
import styles from './link.module.scss';
export function shouldInvokeLinkHandler(event, target) {
    return (event.button === 0 &&
        (!target || target === '_self') &&
        !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey));
}
export const Link = forwardRef(({ children, color = 'blue', className, disabled, noUderline = false, ...restProps }, ref) => {
    const containerClassNames = cx(className, styles.link, {
        [styles.blue]: color === 'blue',
        [styles.black]: color === 'black',
        [styles.white]: color === 'white',
        [styles.disabled]: disabled,
        [styles.noUderline]: noUderline,
    });
    return (React.createElement(BaseLink, { ref: ref, className: containerClassNames, ...restProps }, children));
});
export const RoutedLink = forwardRef(({ children, allowModifiedLinkActions = true, onClick, ...restProps }, ref) => {
    const clickHandler = React.useMemo(() => {
        if (!allowModifiedLinkActions) {
            return (e) => {
                e.preventDefault();
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
            };
        }
        return (e) => {
            if (shouldInvokeLinkHandler(e)) {
                e.preventDefault();
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
            }
        };
    }, [allowModifiedLinkActions, onClick]);
    return (React.createElement(Link, { ref: ref, ...restProps, onClick: clickHandler }, children));
});
//# sourceMappingURL=link.js.map